(function () {
  /*========================
  Mobile : afficher menu
  ========================*/
  function showMobileMenu() {
    var elBtnClose = $('.main-header-top-container-left__menu-close');
    var elAgence = $('.main-header-bottom-container-links-list__item--agency');
    var elEspace = $(
      '.main-header-bottom-container-links-list__item--customer-account'
    );
    var elProfil = $('.main-header-top-container-left__menu');

    //Afficher le bouton fermer
    elBtnClose.classList.remove('hidden');

    //Création de la nav mobile
    var nav = document.createElement('nav');
    nav.id = 'nav-mobile';
    nav.innerHTML =
      elBtnClose.outerHTML +
      '<div class="nav-mobile__container"><ul class="main-header-bottom-container-links__list">' +
      elEspace.outerHTML +
      elAgence.outerHTML +
      elProfil.outerHTML +
      '</ul></div>';

    //Afficher la nav mobile
    var elBoxToShow = nav.querySelectorAll(
      '#nav-mobile .main-header-top-container-left__menu, #nav-mobile span'
    );

    elBoxToShow.forEach(function (el) {
      el.classList.remove('hidden-xs');
    });
    $('body').appendChild(nav);

    //Au clic sur la flèche du menu, afficher le sous-menu
    var elBoxToClickForSubMenu = $$('.menu-item .more');

    elBoxToClickForSubMenu.forEach(function (el) {
      el.addEventListener('click', showSubMenu);
    });

    // Au clic sur le titre du sous menu, afficher le sous-menu (MEX-1095)
    var elBoxToClickForSubMenu2 = $$(
      '#nav-mobile #menu-racine > .menu-item > .link > a'
    );

    elBoxToClickForSubMenu2.forEach(function (el) {
      el.addEventListener('click', showSubMenu);
    });

    // Supprimer la nav mobile
    nav
      .querySelector('.main-header-top-container-left__menu-close')
      .addEventListener('click', function () {
        elBtnClose.classList.add('hidden');
        $('#nav-mobile').remove();
      });

    //Modifier le contenu du profil
    $('#nav-mobile .main-header-top-container-left-menu__default').innerHTML =
      'Choisissez votre profil';
  }

  /*========================
  Mobile : afficher sous-menu
  ========================*/
  function showSubMenu(e) {
    e.preventDefault();

    var elListLinks = $(
      '#nav-mobile .main-header-bottom-container-links__list'
    );
    var elMenu = this.closest('li');
    var elSubMenu = elMenu.querySelector('.sub-menu');

    //Ajouter le titre du profil
    if (elMenu.querySelector('.nav-mobile__subMenuTitle') === null) {
      var titleSubMenuDOM = document.createElement('li');
      titleSubMenuDOM.classList.add('nav-mobile__subMenuTitle');
      titleSubMenuDOM.innerHTML = elMenu.querySelector('.link a').innerHTML;

      elMenu.querySelector('.sub-menu').prepend(titleSubMenuDOM);
    }

    //Ajouter le bouton retour
    if (elMenu.querySelector('.nav-mobile__return') === null) {
      var elReturn = document.createElement('li');
      elReturn.classList.add('nav-mobile__return');
      elReturn.innerHTML = '<a href="%23">Retour</a>';
      elReturn.addEventListener('click', function (e) {
        elListLinks.classList.remove('active');
        e.preventDefault();
      });

      elSubMenu.prepend(elReturn);
    }

    //Afficher/masquer les sous-menu
    var elBoxToHide = $$('.sub-menu');
    elBoxToHide.forEach(function (item) {
      item.classList.remove('active');
    });
    elSubMenu.classList.add('active');
    console.log('test');

    //Animation CSS
    elListLinks.classList.add('active');
  }

  //Affichage du menu mobile
  $('.main-header-top-container-left__menu-toggle').addEventListener(
    'click',
    showMobileMenu
  );

  /*========================
  Mobile : afficher la recherche
  ========================*/
  function showSearch() {
    var elMenu = $('.main__header');
    if (elMenu.classList.contains('main__header--search')) {
      elMenu.classList.remove('main__header--search');
    } else {
      elMenu.classList.add('main__header--search');
    }
  }

  //Affichage de la recherche
  $('.main-header-top-container-right-search__icon').addEventListener(
    'click',
    function () {
      showSearch();
    }
  );

  /*========================
  Desktop : masquer le menu (clic sur la page)
  ========================*/
  window.addEventListener('click', function (e) {
    var elMenu = $('.main-header-top-container-left__menu');
    var elMenuContainer = $('.main-header-top-container-left-menu__container');
    var elMenuDefault = $('.main-header-top-container-left-menu__default');

    if (!elMenu.contains(e.target)) {
      elMenuContainer.classList.remove('active');
      elMenuDefault.classList.remove('active');
    }
  });

  /*========================
  Desktop : afficher le menu
  ========================*/
  $('.main-header-top-container-left-menu__default').addEventListener(
    'click',
    function () {
      var elMenu = this.closest('.main-header-top-container-left__menu');
      var elMenuContainer = elMenu.querySelector(
        '.main-header-top-container-left-menu__container'
      );

      if (
        this.closest('.main-header-top-container-left__menu').querySelector(
          '.active'
        ) === null
      ) {
        this.classList.add('active');
        elMenuContainer.classList.add('active');
      } else {
        this.classList.remove('active');
        elMenuContainer.classList.remove('active');
      }
    }
  );

  /*========================
  Desktop/Mobile : masquer le menu lors d'un changement de résolution
  ========================*/
  function resize() {
    if (window.innerWidth > 768) {
      var elNavMobile = $('#nav-mobile');
      if (elNavMobile != null) {
        elNavMobile.remove();
      }
    }
  }

  window.onresize = resize;

  /*========================
  Desktop/Mobile : accès à l'espace client perso/pro (affichage de la popin)
  ========================*/
  function showPersonalAccessPopin(e) {
    e.preventDefault();

    jQuery
      .ajax({
        url: ajaxurl,
        type: 'POST',
        data: {
          action: 'show_personal_access_popin'
        }
      })
      .done(function (response) {
        var popin = document.createElement('div');
        popin.innerHTML = response;
        popin.classList.add('popin-background');
        $('body').prepend(popin);

        $('.popin-close__icon, .popin-background').addEventListener(
          'click',
          hidePersonalAccessPopin,
          false
        );
      });
  }

  function hidePersonalAccessPopin(e) {
    if (
      e.target.classList.contains('popin-background') ||
      e.target.classList.contains('popin-close__icon') ||
      e.target.classList.contains('popin-close-icon__use')
    ) {
      var elNavMobile = $('.popin-background');
      if (elNavMobile != null) {
        elNavMobile.remove();
      }
    }
  }

  var personalAccessLink = $(
    '.main-header-bottom-container-links-list-item__link--customer-account'
  );

  if (personalAccessLink != null) {
    personalAccessLink.addEventListener(
      'click',
      showPersonalAccessPopin,
      false
    );
  }
})();
